module.exports = require("./lib/browser");


//////////////////
// WEBPACK FOOTER
// ./node_modules/@cliqz-oss/firefox-client/index.js
// module id = 175
// module chunks = 0